export default __webpack_public_path__ + "static/media/template9.6174760f.png";